/* eslint-disable no-nested-ternary */
/* eslint-disable indent */
import FormControl from "@mui/material/FormControl";
import styled from "styled-components";

import Colors from "@constants/Colors";

export const StyledFormControl = styled(FormControl)<{
  disabled: boolean;
  value: string;
  nodata: string;
  error: boolean;
}>`
  .Mui-disabled {
    cursor: not-allowed !important;
  }
  .MuiFormLabel-root {
    color: ${({ disabled, error }: { disabled: boolean; error: boolean }) =>
      disabled
        ? Colors.neutral_gray_300
        : error
        ? Colors.primaryred
        : Colors.neutralblack} !important;
    font-family: "Ringside Regular-Bold" !important;
    font-weight: 400 !important;
    font-size: 18px !important;
    line-height: 20px !important;
    padding-top: 5px
  }
  .MuiInputBase-root {
    border-radius: 8px !important;
  }
  .MuiAutocomplete-input {
      font-family: 'Ringside Regular-Book' !important;
      font-style: normal !important;
      font-weight: 325 !important;
      font-size: 16px !important;
      line-height: 24px !important;
      color: ${({ value }: { value: string }) =>
        value.length > 0 ? Colors.neutral_gray_500 : Colors.neutral_gray_500};
      -webkit-text-fill-color: ${({
        disabled,
        error,
      }: {
        disabled: boolean;
        error: boolean;
      }) =>
        error
          ? Colors.primaryred
          : disabled
          ? Colors.neutral_gray_300
          : Colors.neutral_gray_500} !important;
  }
  .MuiAutocomplete-endAdornment {
    top: auto !important;
  }
  & .MuiAutocomplete-endAdornment .Mui-disabled  {
    filter: ${({ error }: { error: boolean }) =>
      error
        ? ""
        : "opacity(25%) invert(95%) sepia(11%) saturate(654%) hue-rotate(187deg) brightness(92%) contrast(88%) !important"};
  }
  .MuiOutlinedInput-notchedOutline {
    border: ${({ nodata }: { nodata: string }) =>
      nodata.length
        ? `2px solid ${Colors.error_500}`
        : `2px solid ${Colors.neutral_gray_300}`} !important;
    color: ${({ nodata }: { nodata: string }) =>
      nodata.length ? Colors.error_500 : Colors.neutral_gray_300} !important;
    font-size: 18px !important;
  }
  .Mui-error {
    color: ${Colors.primaryred} !important;
  }
  .MuiAutocomplete-clearIndicator {
    padding: 0px !important;
    visibility: unset !important;
  }
  .MuiAutocomplete-popper {
    margin-top: 10px !important;
    border: 1px solid ${Colors.neutral_gray_300} !important;
    border-radius: 6px !important;
    box-shadow: ${Colors.Elevation_4};
  }
  .MuiAutocomplete-option {
    font-family: "Ringside Regular-Book" !important;
    font-weight: 325 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    padding: 8px 16px !important;
  }
  .MuiAutocomplete-listbox {
    padding: 0px !important;
    .MuiAutocomplete-option[aria-selected="true"].Mui-focused {
    background-color: ${Colors.neutral_gray_100} !important;
    color: ${Colors.primary} !important;
  }
  
`;
